import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import {
	SetCIOrigins,
	SetProductListByIntegration,
	SetFormTypes,
	SetCIOrganizations
} from '../../state/actions/global-configuration.actions';

import { INTEGRATIONS } from '../../model/global-configuration.constant';

@Injectable({
	providedIn: 'root'
})
export class CIJobTypesLoaderService implements CanActivate {
	constructor(private store: Store) {
	}

	/**
	 * Load all util lists for lender routes.
	 * @param childRoute
	 * @param state
	 */
	canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
		// eslint-disable-next-line no-async-promise-executor
		return new Promise(async resolve => {
			await this.store.dispatch(new SetCIOrigins()).toPromise();
			await this.store.dispatch(new SetCIOrganizations('')).toPromise();
			await this.store.dispatch(new SetProductListByIntegration(INTEGRATIONS.APPSCOPE)).toPromise();
			await this.store.dispatch(new SetProductListByIntegration(INTEGRATIONS.ACUITY)).toPromise();
			await this.store.dispatch(new SetProductListByIntegration(INTEGRATIONS.CMP_ACUTIY)).toPromise();
			await this.store.dispatch(new SetFormTypes()).toPromise();
			return resolve(true);
		});
	}
}
